/**
 * Ryan O'Dowd
 * 2024-08-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
  View,
} from 'react-native';
import Checkbox from '@components/common/Checkbox';
import React from 'react';
import Switch from '@components/common/Switch';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';
import {
  updateUserSettings,
} from '@utils/store/actions';

const SearchFilterSection = (props: SearchFilterSectionProps) => {
  const dispatch = hooks.useTypedDispatch();
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={[styles.dialogSectionWrapper, !props.enabled && styles.disabledSection]}>
      <View style={styles.titleAndSwitch}>
        <Text style={[styles.dialogSectionTitle, !props.enabled && styles.disabledText]}>{props.sectionName}</Text>
        <Switch
          value={!!props.enabled}
          ios_backgroundColor={styles.colors.gray}
          trackColor={{true: Platform.OS === 'ios' ? styles.colors.primary : styles.colors.lightGray, false: Platform.OS === 'ios' ? styles.colors.gray : styles.colors.gray}}
          thumbColor={Platform.OS === 'ios' ? undefined : props.enabled ? styles.colors.primary : styles.colors.white}
          onValueChange={() => {
            dispatch(updateUserSettings({[props.settingColumnName]: +!props.enabled})); // @TODO: the rerender is WAY too slow here
          }}
        />
      </View>
      <View style={styles.subFiltersWrapper}>
        {props.subFilters.map((subFilter) => {
          return (
            <View
              key={subFilter.columnName}
              style={styles.checkboxWrapper}
            >
              <Checkbox
                isChecked={!!subFilter.value}
                disabled={!props.enabled}
                onPress={() => {
                  dispatch(updateUserSettings({[subFilter.columnName]: +!subFilter.value})); // @TODO: the rerender is WAY too slow here
                }}
                label={subFilter.readableName}
                labelColor={styles.colors.dialogText}
                labelStyles={!props.enabled && styles.disabledText}
              />
              {subFilter.description && <Text style={[styles.descriptionText, !props.enabled && styles.disabledText]}>{subFilter.description}</Text>}
            </View>
          );
        })}
      </View>
    </View>
  );
};

class SearchFilterSectionProps {
  settingColumnName: string;
  enabled: 0 | 1; // @TODO: boolean
  sectionName: string;
  subFilters: {readableName: any, columnName: string, value: number, description?: string}[];
};

export default SearchFilterSection;
